<template>
  <div class="product-content">
    <div class="title-content">
      <div class="big-title">{{ $t("route.product") }}</div>
      <div class="small-title">Product service</div>
    </div>
    <div class="product-select-content">
      <div
        :class="[
          'select-item',
          activeSelect === 'one' ? 'active-select-item' : '',
        ]"
      >
        <div
          class="select-item-header-content"
          @click="selectProductItem('one')"
        >
          <span>{{ $t("product.product_introduce") }}</span>
          <img src="../../../assets/mobile/arrow.png" />
        </div>
        <div class="home-product-img-content" v-show="activeSelect === 'one'">
          <div
            class="img-content"
            :class="{ 'no-margin-left': (index + 1) % 3 === 1 }"
            :key="item.id"
            v-for="(item, index) in breedPrductList"
            @click="productDetailClick(item, 'product')"
          >
            <img :src="item.mainPicture" alt="" />
            <span>{{ item.productName }}</span>
          </div>
        </div>
        <!-- <div class="select-item-content" v-show="activeSelect === 'one'">
          <div
            :key="item.id"
            v-for="item in breedPrductList"
            @click="productDetailClick(item,'product')"
            :class="[
              'select-item-content-item',
              item.detailShow ? 'active-font-color' : '',
            ]"
          >
            {{ item.productName }}
            <div
              class="detail-content"
              v-if="item.detailShow"
              v-html="filterDeatilCss(item.details)"
              style="font-size: 2rem; color: #2b2b2b"
            ></div>
          </div>
        </div> -->
      </div>
      <div
        :class="[
          'select-item',
          activeSelect === 'two' ? 'active-select-item' : '',
        ]"
      >
        <div
          class="select-item-header-content"
          @click="selectProductItem('two')"
        >
          <span>{{ $t("product.platform") }}</span>
          <img src="../../../assets/mobile/arrow.png" />
        </div>
        <div class="select-item-content" v-show="activeSelect === 'two'">
          <div
            :key="item.id"
            v-for="item in uyuPlatformList"
            :class="[
              'select-item-content-item',
              item.detailShow ? 'active-font-color' : '',
            ]"
            @click.stop="productDetailClick(item, 'two')"
          >
            {{ item.introductionTitle }}
            <div
              class="platform-content"
              v-if="item.detailShow"
              style="font-size: 2rem; color: #2b2b2b"
            >
              <div class="platform-detail-small-img">
                <img :src="item.detailPicture1" alt="" />
                <img :src="item.detailPicture2" alt="" />
              </div>
              <div class="platform-detail-text">
                <div
                  class="platform-detail-text-content"
                  v-html="filterDeatilCss(item.details)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="[
          'select-item',
          activeSelect === 'three' ? 'active-select-item' : '',
        ]"
      >
        <div
          class="select-item-header-content"
          @click="selectProductItem('three')"
        >
          <span>{{ $t("product.tutorial") }}</span>
          <img src="../../../assets/mobile/arrow.png" />
        </div>
        <div class="select-item-content" v-show="activeSelect === 'three'">
          <div
            :key="item.id"
            v-for="item in tutorialList"
            :class="[
              'select-item-content-item',
              item.detailShow ? 'active-font-color' : '',
            ]"
            @click="productDetailClick(item, 'three')"
          >
            {{ item.title }}
            <!-- <div
              class="tutorial-content"
              v-if="item.detailShow"
              style="font-size: 2rem; color: #2b2b2b"
            ></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="title-content" style="padding-top: 4.8rem">
      <div class="big-title">{{ $t("route.videohub") }}</div>
    </div>
    <!--  -->
    <div class="video-img-content">
      <div
        :key="index"
        v-for="(item, index) in videoList"
        class="case-img-item"
      >
        <div class="case-img">
          <img :src="item.detailsPicture" />
          <img
            @click="playVideoClick(item.detailsVideo)"
            class="play-img"
            src="../../../assets/mobile/play.png"
          />
        </div>
        <div class="case-text">{{ item.title }}</div>
      </div>
    </div>
    <div
      v-if="videoShow"
      @click.self="cancelVideoClick"
      class="video-play-popup"
    >
      <div class="video-content">
        <video
          autoplay
          object-fit="fill"
          controls
          :src="videoDateilUrl"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/axios/index.js";
export default {
  name: "mobile-case",
  props: {
    msg: String,
  },
  data() {
    return {
      DomParser: new DOMParser(),
      params: {
        page: 1,
        pageSize: 100,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      activeSelect: "",
      customerCaseList: [],
      videoList: [],
      breedPrductList: [],
      uyuPlatformList: [],
      tutorialList: [],
      videoDateilUrl: "",
      videoShow: false,
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.getPageList();
    if (this.$route.query["type"]) {
      this.activeSelect = this.$route.query["type"];
    }
  },
  mounted() {},
  methods: {
    getPageList() {
      this.getViedoPage();
      this.getBreedPrductPage();
      this.getUyuPlatformPage();
      this.getTutorialPage();
    },
    // 切换选中项x
    selectProductItem(type) {
      type === this.activeSelect
        ? (this.activeSelect = "")
        : (this.activeSelect = type);
    },
    playVideoClick(videoRrl) {
      this.videoDateilUrl = videoRrl;
      this.videoShow = true;
    },
    cancelVideoClick() {
      this.videoShow = false;
    },
    getViedoPage() {
      const url = `/frontVideoShow/page`;
      http
        .post(url, this.params)
        .then((res) => {
          if (res.code === "00000") {
            this.videoList = res.data.list;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取U鱼数智化产品
    getBreedPrductPage() {
      const url = `/frontProductDescription/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.breedPrductList = res.data;
            this.breedPrductList.forEach((item) => {
              this.$set(item, "detailShow", false);
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取U鱼智慧渔业管理平台
    getUyuPlatformPage() {
      const url = `/frontPlatformInformation/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.uyuPlatformList = res.data;
            this.uyuPlatformList.forEach((item) => {
              this.$set(item, "detailShow", false);
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取使用教程
    getTutorialPage() {
      const url = `/frontUseTutorial/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.tutorialList = res.data;
            this.tutorialList.forEach((item) => {
              this.$set(item, "detailShow", false);
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    productDetailClick(item, type) {
      if (type === "product") {
        this.$router.push({
          name: "mobile-product-detail",
          params: item,
          query: {
            productId: item.id,
          },
        });
        return;
      }
      if (item.detailShow) {
        if (type !== "two") {
          item.detailShow = false;
        }
        return;
      }
      this.breedPrductList.forEach((item) => (item.detailShow = false));
      this.uyuPlatformList.forEach((item) => (item.detailShow = false));
      this.tutorialList.forEach((item) => (item.detailShow = false));
      if (type === "three") {
        this.videoDateilUrl = item.detailsVideo;
        this.videoShow = true;
        return;
      }
      if (type === "two") {
        this.getPlatFormImgList(item);
      }
      item.detailShow = true;
    },
    filterDeatilCss(detail) {
      detail = detail.replace(
        /\<img/g,
        `<img style="width:50rem;height:auto;margin-left: auto; margin-right: auto;display:block"`
      );
      return detail;
    },
    // 获取当前点击平台下的所有图片
    getPlatFormImgList() {
      setTimeout(() => {
        const dom = document.querySelector(".platform-detail-text-content");
        dom.childNodes.forEach((item) => {
          if (item.childNodes.length !== 0) {
            const nameBol = item.childNodes[0].localName;
            if (nameBol && nameBol === "img") {
              item.childNodes[0].onclick = function () {
                window.location.href=(item.childNodes[0].src);
              }
            }
          }
        });
      }, 1000);
    },
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.getPageList();
    },
  },
};
</script>
<style lang="less" scoped>
.product-content {
  box-sizing: border-box;
  overflow: scroll;

  .active-font-color {
    color: #1ea5ff !important;
  }
  .title-content {
    padding-top: 9.4rem;
    padding-bottom: 7.4rem;
    text-align: center;
    .big-title {
      font-size: 4.2rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2b2b2b;
    }

    .small-title {
      font-size: 2.4rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #1ea5ff;
    }
  }
  .product-select-content {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
    background: #f5f5f5;
    .select-item {
      width: 68.4rem;
      border-bottom: 1px solid #cbcbcb;
      padding: 4rem 0;
      box-sizing: border-box;
      font-size: 3.6rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #a3a3a3;
      &:last-child {
        border-bottom: unset;
      }
      .select-item-header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 2rem;
          height: 1.2rem;
        }
      }
      .select-item-content {
        .select-item-content-item {
          font-size: 2.8rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #a3a3a3;
          box-sizing: border-box;
          padding: 3rem 0;
          border-bottom: 1px solid #e7e7e7;
          &:last-child {
            border: unset;
            padding-bottom: unset;
          }
          .detail-content {
            overflow: hidden;
            box-sizing: border-box;
            padding-top: 2rem;
          }
          .platform-content {
            overflow: hidden;
            box-sizing: border-box;
            padding-top: 2rem;

            .platform-detail-small-img {
              width: 100%;
              box-sizing: border-box;
              padding-bottom: 2rem;
              display: flex;
              justify-content: space-between;
              img {
                width: 32rem;
                // height: 20rem;
              }
            }
            .platform-detail-text {
              box-sizing: border-box;
              padding-bottom: 2rem;
              .platform-detail-text-title {
                box-sizing: border-box;
                padding-bottom: 2rem;
                font-size: 2.8rem;
                font-family: Alibaba PuHuiTi;
                font-weight: 500;
                color: #2b2b2b;
              }
              .platform-detail-text-content {
                // letter-spacing:.6rem;
                font-size: 2rem;
                font-family: Alibaba PuHuiTi;
                font-weight: 500;
                color: #2b2b2b;
              }
            }
          }
          .tutorial-content {
            overflow: hidden;
            box-sizing: border-box;
            padding-top: 2rem;
          }
        }
      }
      .home-product-img-content {
        width: 100%;
        box-sizing: border-box;
        display: inline-flex;
        flex-wrap: wrap;
        border-radius: 2rem;
        overflow: hidden;
        .img-content {
          margin-top: 3.8rem;
          width: 21.2rem;
          border-radius: 2rem;
          margin-left: 1.8rem;
          display: flex;
          flex-direction: column;
          img {
            // width: 21.2rem;
            // min-height: 16rem;
            // max-height: 16rem;
            border-radius: 2rem;
            // width: 100%;
            // height: 100%;
          }
          span {
            text-align: center;
            box-sizing: border-box;
            display: inline-block;
            margin: 2.6rem 0 0 0 !important;
            font-size: 2rem;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #a3a3a3;
          }
        }
        .no-margin-left {
          margin-left: unset;
        }
      }
    }
    .active-select-item {
      .select-item-header-content {
        color: #1ea5ff;
      }
    }
  }
  .video-img-content {
    overflow: scroll;
    box-sizing: border-box;
    padding: 0 4rem 4rem 4rem;

    .case-img-item {
      width: 31.2rem;
      display: inline-flex;
      flex-direction: column;
      box-sizing: border-box;
      overflow: hidden;
      &:nth-child(2n) {
        margin-left: 4.6rem;
      }
      &:nth-child(1n + 1) {
        margin-top: 4.6rem;
      }
      &:nth-child(1) {
        margin-top: unset;
      }
      &:nth-child(2) {
        margin-top: unset;
      }
      .case-img {
        position: relative;
        overflow: hidden;
        width: 30rem;
        height: 20rem;
        background: #ffffff;
        border-radius: 0.6rem;
        img {
          width: 100%;
          height: 100%;
        }
        .play-img {
          width: 10.8rem;
          height: 10.8rem;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          position: absolute;
        }
      }
      .case-text {
        width: 100%;
        margin-top: 1.4rem;
        text-align: center;
        font-size: 2.4rem;
      }
    }
  }
  .video-play-popup {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    .video-content {
      position: fixed;
      width: 68.2rem;
      height: 45.2rem;
      top: 50%;
      left: 50%;
      background: white;
      border-radius: 2rem;
      overflow: hidden;
      transform: translateX(-50%) translateY(-50%);
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
